import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import LinkMUI from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom"; // Import Link
import { Box, Paper } from "@mui/material";

export default function CustomSeparator({ pageName }) {
  let location = useLocation();
  const pathname = "/ppkm" + location.pathname;
  const breadcrumbs = [
    <LinkMUI
      underline={pathname === "/ppkm/admin/dashboard" ? "always" : "hover"}
      key="1"
      color="inherit"
      // component={Link}
      href="/ppkm/admin/dashboard"
    >
      Dashboard
    </LinkMUI>,
    pageName === "resources" || pageName === "create_resources"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/resources" ? "always" : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/resources"
          >
            Resources
          </LinkMUI>,
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/create_resources" ? "always" : "hover"
            }
            key="3"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/create_resources"
          >
            Create Resources
          </LinkMUI>,
        ]
      : pageName === "broadcasts" || pageName === "create_broadcast"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/broadcasts" ? "always" : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/broadcasts"
          >
            Broadcasts
          </LinkMUI>,
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/create_broadcast" ? "always" : "hover"
            }
            key="3"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/create_broadcast"
          >
            Create Broadcast
          </LinkMUI>,
        ]
      : pageName === "event"
      ? [
          <LinkMUI
            underline={pathname === "/ppkm/admin/event" ? "always" : "hover"}
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/event"
          >
            Events
          </LinkMUI>,
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/create_event" ? "always" : "hover"
            }
            key="3"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/create_event"
          >
            Create Event
          </LinkMUI>,
        ]
      : pageName === "membership"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/corporate_membership_applications"
                ? "always"
                : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/corporate_membership_applications"
          >
            Corporate Membership
          </LinkMUI>,
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/individual_membership_applications"
                ? "always"
                : "hover"
            }
            key="3"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/individual_membership_applications"
          >
            Individual Membership
          </LinkMUI>,
        ]
      : pageName === "secretariat" || pageName === "reg_secretariat"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/secretariat_list" ? "always" : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/secretariat_list"
          >
            Secretariat List
          </LinkMUI>,
          // <LinkMUI
          //   underline={
          //     pathname === "/ppkm/admin/reg_sercretariat" ? "always" : "hover"
          //   }
          //   key="3"
          //   color="inherit"
          //   // component={Link}
          //   href="/ppkm/admin/reg_sercretariat"
          // >
          //   Register Secretariat
          // </LinkMUI>,
        ]
      : pageName === "add_members"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/corporate_membership_applications"
                ? "always"
                : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/corporate_membership_applications"
          >
            Corporate Membership
          </LinkMUI>,
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/add_corporate_member"
                ? "always"
                : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/add_corporate_member"
          >
            Add Member
          </LinkMUI>,
        ]
      : pageName === "invoice"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/membership_invoice" ? "always" : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/membership_invoice"
          >
            Membership Invoice
          </LinkMUI>,
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/event_invoice" ? "always" : "hover"
            }
            key="3"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/event_invoice"
          >
            Event Invoice
          </LinkMUI>,
        ]
      : pageName === "event_category"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/event_categories" ? "always" : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/event_categories"
          >
            Event Categories
          </LinkMUI>,
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/create_event_categories"
                ? "always"
                : "hover"
            }
            key="3"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/create_event_categories"
          >
            Create Event Category
          </LinkMUI>,
        ]
      : pageName === "resources_category"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/resources_categories"
                ? "always"
                : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/resources_categories"
          >
            Resources Categories
          </LinkMUI>,
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/create_resources_categories"
                ? "always"
                : "hover"
            }
            key="3"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/create_resources_categories"
          >
            Create Resources Category
          </LinkMUI>,
        ]
      : pageName === "photo_gallery"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/photo_gallery" ? "always" : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/photo_gallery"
          >
            Photo Gallery
          </LinkMUI>,
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/upload_photo" ? "always" : "hover"
            }
            key="3"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/upload_photo"
          >
            Upload Photo
          </LinkMUI>,
        ]
      : pageName === "signatures" || pageName === "create_signature"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/signatures" ? "always" : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/signatures"
          >
            Signatures
          </LinkMUI>,
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/create_signature_info"
                ? "always"
                : "hover"
            }
            key="3"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/create_signature_info"
          >
            Create Signature
          </LinkMUI>,
        ]
      : pageName === "invoice_notes"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/invoice_notes" ? "always" : "hover"
            }
            key="3"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/invoice_notes"
          >
            Invoice Notes
          </LinkMUI>,
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/create_invoice_notes"
                ? "always"
                : "hover"
            }
            key="3"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/create_invoice_notes"
          >
            Create Invoice Notes
          </LinkMUI>,
        ]
      : pageName === "cms_audits"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/cms_audits" ? "always" : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/cms_audits"
          >
            CMS Audits
          </LinkMUI>,
        ]
      : pageName === "mobile_audits"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/mobile_audits" ? "always" : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/mobile_audits"
          >
            Mobile Audits
          </LinkMUI>,
        ]
      : pageName === "web_audits"
      ? [
          <LinkMUI
            underline={
              pathname === "/ppkm/admin/web_audits" ? "always" : "hover"
            }
            key="2"
            color="inherit"
            // component={Link}
            href="/ppkm/admin/web_audits"
          >
            Web Audits
          </LinkMUI>,
        ]
      : "",
  ];

  return (
    <Stack sx={{ height: 50, padding: 2 }} component={Paper} spacing={2}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}
